import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './interceptor/auth-guard';

import { HomepageComponent } from './homepage/homepage.component';
import { AppointmentIndexComponent } from './appointment/appointment-index/appointment-index.component';
import { AppointmentNewComponent } from './appointment/appointment-new/appointment-new.component';
import { LoginFormComponent } from './login/login-form/login-form.component';
import { PatientIndexComponent } from './patient/patient-index/patient-index.component';
import { PatientShowComponent } from './patient/patient-show/patient-show.component';
import { PatientNewComponent } from './patient/patient-new/patient-new.component';
import { PrescriptionIndexComponent } from './prescription/prescription-index/prescription-index.component';
import { PrescriptionTemplateIndexComponent } from './prescription-template/prescription-template-index/prescription-template-index.component';
import { PrescriptionTemplateNewComponent } from './prescription-template/prescription-template-new/prescription-template-new.component';
import { PrescriptionTemplateShowComponent } from './prescription-template/prescription-template-show/prescription-template-show.component';
import { SchedulingNewComponent } from './scheduling/scheduling-new/scheduling-new.component';
import { SchedulingIndexComponent } from './scheduling/scheduling-index/scheduling-index.component';
import { ChangePasswordComponent } from './login/password/change-password/change-password.component';
import { ExamTemplateIndexComponent } from './exam-template/exam-template-index/exam-template-index.component';
import { ExamTemplateNewComponent } from './exam-template/exam-template-new/exam-template-new.component';
import { ExamTemplateShowComponent } from './exam-template/exam-template-show/exam-template-show.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'login', component: LoginFormComponent },
  { path: 'senha', component: ChangePasswordComponent, canActivate: [AuthGuard] },
  { path: 'home', component: HomepageComponent, canActivate: [AuthGuard] },

  { path: 'paciente', component: PatientIndexComponent, canActivate: [AuthGuard] },
  { path: 'paciente/novo', component: PatientNewComponent, canActivate: [AuthGuard] },
  { path: 'paciente/:id', component: PatientShowComponent, canActivate: [AuthGuard] },
  { path: 'paciente/:id/atendimento', component: AppointmentIndexComponent, canActivate: [AuthGuard] },
  { path: 'paciente/:id/atendimento/novo', component: AppointmentNewComponent, canActivate: [AuthGuard] },
  { path: 'paciente/:id/receita', component: PrescriptionIndexComponent, canActivate: [AuthGuard] },
  { path: 'paciente/:id/agendamento/novo', component: SchedulingNewComponent, canActivate: [AuthGuard] },

  { path: 'receita', component: PrescriptionTemplateIndexComponent, canActivate: [AuthGuard] },
  { path: 'receita/nova', component: PrescriptionTemplateNewComponent, canActivate: [AuthGuard] },
  { path: 'receita/:id', component: PrescriptionTemplateShowComponent, canActivate: [AuthGuard] },

  { path: 'solicitacao', component: ExamTemplateIndexComponent, canActivate: [AuthGuard] },
  { path: 'solicitacao/nova', component: ExamTemplateNewComponent, canActivate: [AuthGuard]},
  { path: 'solicitacao/:id', component: ExamTemplateShowComponent, canActivate: [AuthGuard]},

  { path: 'agenda', component: SchedulingIndexComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }) ],
  exports: [ RouterModule ]
})
export class McRoutingModule { }
